import { useMemo, useState } from 'react';
import { Icon } from '../icons';
import { formatBytes, formatDate } from '../utils';

export function Sources({ data, onSelect }) {
  const [category, setCategory] = useState('All');
  const categories = ['All', ...new Set(data.sources.map((source) => source.category))];
  const sources = useMemo(() => category === 'All' ? data.sources : data.sources.filter((source) => source.category === category), [data.sources, category]);
  return (
    <main className="sources page-view">
      <header className="page-heading"><p>Sources</p><h1>Inspect the record.</h1><span>Every file contributing to this host snapshot, with size and freshness.</span></header>
      <div className="source-summary"><strong>{data.metrics.sourceFiles}</strong><span>files</span><strong>{formatBytes(data.metrics.totalBytes)}</strong><span>on disk</span><code>{data.root.replace(/^\/Users\/[^/]+/, '~')}</code></div>
      <div className="filter-rail"><div>{categories.map((value) => <button key={value} className={category === value ? 'is-active' : ''} onClick={() => setCategory(value)}>{value}</button>)}</div></div>
      <div className="source-table">
        <div className="source-table__header"><span>Name</span><span>Kind</span><span>Modified</span><span>Size</span></div>
        {sources.map((source) => (
          <button key={source.path} disabled={!source.isText} onClick={() => onSelect({ ...source, kind: 'source', title: source.name, status: 'current', project: source.category, description: source.path })}>
            <span><Icon name="document" size={17}/><span><strong>{source.name}</strong><small>{source.path}</small></span></span><span>{source.category}</span><span>{formatDate(source.updatedAt)}</span><span>{formatBytes(source.size)}</span><Icon name="chevron" size={14}/>
          </button>
        ))}
      </div>
    </main>
  );
}
